/*
export const environment = {
  production: false,
firebase: {
  apiKey: "AIzaSyCJvPerQkXq14bttUfNe-cvdzjwVlZgsr4",
  authDomain: "servitrack-dev.firebaseapp.com",
  projectId: "servitrack-dev",
  storageBucket: "servitrack-dev.firebasestorage.app",
  messagingSenderId: "856853947842",
  appId: "1:856853947842:web:50db1e39c7e0a68351625b",
  measurementId: "G-EEGNTB8WJ1"
}
}*/


export const environment = {
  firebase: {
    projectId: 'bikeroom-f1cc5',
    appId: '1:3975802414:web:11777753efd0a3f66779bf',
    storageBucket: 'bikeroom-f1cc5.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyB8nKb11gbAqHMfnXSWxmf1lgIafLohqCo',
    authDomain: 'bikeroom-f1cc5.firebaseapp.com',
    messagingSenderId: '3975802414',
  },
  production: true
};
